

  export default {
    name: `MyCheckMedicalTestStatus`,
    methods: {
      show: () => {return [`ordered_placed`].includes(this.myCheck?.status.code)}
    },
    computed: {
      fullCandidateName() {
        return `${this.myCheck?.candidate?.first_name} ${this.myCheck?.candidate?.last_name}`
      }
    },
    props: {
      myCheck: {
        type: Object,
        default: undefined
      }
    },
  }

